import styled from "styled-components";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .searchResults {
    margin-bottom: 3rem !important;
  }
  .warning {
    text-align: center;
  }
  .loadMore {
    margin-top: 20px;
    text-align: center;
  }
`;
